import { render, staticRenderFns } from "./DataSheetPrev.vue?vue&type=template&id=5752953e&scoped=true"
import script from "./DataSheetPrev.vue?vue&type=script&lang=js"
export * from "./DataSheetPrev.vue?vue&type=script&lang=js"
import style0 from "./DataSheetPrev.vue?vue&type=style&index=0&id=5752953e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752953e",
  null
  
)

export default component.exports